import { render } from "./GroupsPage.vue?vue&type=template&id=bd32adcc&scoped=true"
import script from "./GroupsPage.vue?vue&type=script&lang=js"
export * from "./GroupsPage.vue?vue&type=script&lang=js"

import "./GroupsPage.vue?vue&type=style&index=0&id=bd32adcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd32adcc"]])

export default __exports__